import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import type { PicrossPresence } from "./Player";
import { registerPicrossTranslations } from "./i18n";
import { localFeedback } from "./localCheck";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  PicrossDefinition,
  PicrossProgress,
  PicrossSolution,
  PicrossSubmission,
} from "./types";

registerPicrossTranslations(i18n);

export const picrossModule: PuzzleTypeModule<
  PicrossDefinition,
  PicrossSubmission,
  PicrossProgress,
  PicrossSolution,
  PicrossPresence
> = {
  key: "picross",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  localFeedback,
};
